import React, { useState } from "react";
import classes from "../Login.module.scss";
import RoundedButton from "../../Buttons/RoundedButton/RoundedButton";
import TagInput from "../../UI/Inputs/TagInput";
import H1 from "../../UI/Titles/H1/h1";
import H2 from "../../UI/Titles/H2/h2";
import { useTranslation } from "react-i18next";
import Checkbox from "../../UI/Checkbox/Checkbox";
import * as kApi from "../../../constants/api";
import barOr from "../../../assets/images/barOr.svg";
import logoGoogle from "../../../assets/images/logoGoogle.svg";
// import * as routes from "../../../constants/routes";
// import { Switch, Route, Redirect } from "react-router-dom";

const LoginForm = ({
  login = {},
  errorMsg = null,
  formSubmit = () => {},
  onChange = () => {},
  bottomLink = () => {},
  googleSignIn = ()=>{},
  createAccount = () => {},
}) => {
  const { t } = useTranslation();
  const [hasRead, setHasRead] = useState();
  return (
    <>
      <form className={classes.Form} onSubmit={(event) => formSubmit(event)}>
        <H1 className={classes.Title}>{t("global.login_new")}</H1>
        <p className={classes.Title}>{t("global.login_new_afinando_info")}</p>
        {errorMsg && <div className={classes.ErrorMsg}>{t(errorMsg)}</div>}
        <TagInput
          type="email"
          name="username"
          className={classes.Input}
          placeholder={t("global.email")}
          value={login.username}
          onChange={onChange}
          required
        />
        <TagInput
          type="password"
          name="password"
          className={classes.Input}
          placeholder={t("global.password")}
          value={login.password}
          onChange={onChange}
          required
        />
        <button
          tabIndex="0"
          className={classes.TextInfo + " link"}
          onClick={() => bottomLink()}
        >
          {t("global.forgot_password")}
        </button>
        <Checkbox value={hasRead} onClick={() => setHasRead(!hasRead)}>
          <span onClick={() => setHasRead(true)}>
            {t("global.i_have_read_and_agree_to_the_terms") + " "}
          </span>
          <a
            target="_blank"
            rel="noopener noreferrer"
            title={t(global.use_terms)}
            href={kApi.STATIC_FILE_USE_TERMS}
          >
            {t("global.terms_of_use")}
          </a>
          <span onClick={() => setHasRead(true)}>
            {" "}
            <br />
            {t("global.and")}{" "}
          </span>
          <a
            target="_blank"
            rel="noopener noreferrer"
            title={t(global.priv_politics)}
            href={kApi.STATIC_FILE_PRIV_POLITICS}
          >
            {t("global.terms_of_privacy")}
          </a>
        </Checkbox>

        <div className={classes.wrapper}>
          <RoundedButton
            disable={!hasRead}
            className={classes.BtnEnter}
            type="submit"
            text={t("global.signin")}
          />
        </div>
       {/*  <div className={classes.ContentBar} style={{ bottom: "220px" }}>
          <img src={barOr} className={classes.BarOr} alt="tag idioma" />
        </div>
        <div className={classes.wrapper}>
          <RoundedButton
            className={classes.BtnGoogle}
            style={{ bottom: "70px", width: "353px" }}
            type="button"
            icon={
              <img
                src={logoGoogle}
                className={classes.iconGoogle}
                alt="tag idioma"
              />
            }
            onClick={(e) => googleSignIn(e)}
            text={t("continuar com o google")}
          />
          
        </div> */}

        <div
          className={classes.SignUpArea}
          style={{ marginTop: "45px", marginBottom: "0" }}
        >
          <H2 className={classes.TextCenter}>
            {t("global.not_registered_yet")}
          </H2>
          <RoundedButton
            text={t("global.create_your_account")}
            className={classes.BtnSignUp}
            //btnType={BTN_TYPE_TRANSPARENT}
            //size={buttonsConf.BTN_SIZE_SM}
            onClick={() => createAccount()}
          />
        </div>
        <div className={classes.policyLink}>
          <a
              target="_blank"
              rel="noopener noreferrer"
              title={t(global.priv_politics)}
              href={kApi.STATIC_FILE_SECURITY_POLICY}
            >
              {t("global.security_policy")}
            </a>
        </div>
      </form>
    </>
  );
};

export default LoginForm;
